import { render, staticRenderFns } from "./StudyView.vue?vue&type=template&id=2279e4f0"
import script from "./StudyView.vue?vue&type=script&lang=js"
export * from "./StudyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports